module.exports = __webpack_public_path__ + "static/media/search.000f2a2d.svg";